import { Box } from '@mui/material';
import React, { PropsWithChildren, useCallback } from 'react';

import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';
import { usePageContext } from '@/contexts/pageContext/Page.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useKnowMeNavigate } from '@/utils/useKnowMeNavigation.util.ts';

interface OcdRouterLinkProps extends PropsWithChildren {
  className?: string;
  id: MenuItemEnum;
  route: RouteEnum;
}

export const OcdRouterLink: React.FC<OcdRouterLinkProps> = props => {
  const { children, className, id, route } = props;
  const { push } = useKnowMeNavigate();
  const { setPageDetails } = usePageContext();

  const handleClick = useCallback(() => {
    push(route);
    setPageDetails({ title: id });
  }, [push, setPageDetails, id, route]);

  return (
    <Box className={className} onClick={handleClick}>
      {children}
    </Box>
  );
};
